import React from "react";
import { Col, Row, Typography } from "antd";
import NoOneWinnerIcon from "@components/svg/NoOneWinnerIcon";
import AvatarDefault from "@assets/images/ava.svg";
import { useTranslation } from "react-i18next";
import PhoneNumber from "@components/PhoneNumber";

const { Title, Text } = Typography;
const CurrentBid = ({ product, isResultOverview, isWinner, isNoOneWinner }) => {
  const { t } = useTranslation();

  return (
    <Row>
      {!isResultOverview && (
        <Col xs={24} md={24} lg={24} xxl={24}>
          <div className="current-bid-block">
            <Title level={5} className="page-block-product-sub-title">{t("product.market_price")}</Title>
            <Text className="page-block-product-price">{t("currency_sign")} {product?.product_price}</Text>
          </div>
        </Col>
      )}

      {isWinner &&
        (
          <>
            <Col xs={24} lg={24} xxl={24}>
              <div className="current-bid-block">
                <Title level={5} className="page-block-product-sub-title">{t("product.final_price")}</Title>
                <Text className="page-block-product-price ">{t("currency_sign")} {product?.auction_price}</Text>
              </div>
            </Col>
            <Col xs={24} lg={24} xxl={24}>
              <div className="current-bid-block">
                <Title level={5} className="page-block-product-sub-title">{t("product.winner")}</Title>
                <div className="list-item no-padding">
                  <Row gutter={[4, 0]} justify="space-between" align="middle">
                    <Col xs={24} md={24}>
                      <div className="list-item-wrapper">
                        <div>
                          <Text className="list-item-image" style={{ backgroundImage: `url(${product?.image || AvatarDefault})` }} />
                        </div>
                        <div className="list-item-user">
                          <Text className="list-item-name">{product?.name}</Text>
                          <PhoneNumber
                            value={product?.isdn}
                            className="list-item-phone"
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
          </>
        )
      }

      {isNoOneWinner && (
        <Col xs={24} md={24}>
          <div className="current-bid-block">
            <Title level={5} className="page-block-product-sub-title">{t("product.no_winner")}</Title>
            <NoOneWinnerIcon />
          </div>
        </Col>
      )}
    </Row>
  );
};

export default CurrentBid;

